export default "__VITE_ASSET__DdBskev6__"